import { render, staticRenderFns } from "./SortForm.vue?vue&type=template&id=a29130be"
import script from "./SortForm.vue?vue&type=script&lang=js"
export * from "./SortForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports